module.exports = __webpack_public_path__ + "img/smallFeedback.20c75761.svg";